<template>
  <form class="userForm" v-if="user || isAddUser">
    <form-group>
      <field name="Name" :value="user.name" v-model="user.name"/>
    </form-group>
    <form-group>
      <field name="Email" :value="user.email" type="email" v-model="user.email"/>
    </form-group>
    <form-group>
      <field name="Password" :value="user.password" type="password" v-model="user.password"/>
    </form-group>
    <form-group>
      <dropdown name="Role" :options="roles.options" :current="user.role" v-model="user.role"/>
    </form-group>
    <heading type="h2">Manage Clients</heading>
    <list v-model="user.clients" :data="this.clients" :currentIds="user.clients" />
    <form-group>
      <button-cta :onClick="submit">Save</button-cta>
    </form-group>
  </form>
</template>

<script>
import FormGroup from '@/components/Form/FormGroup/form-group'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import Field from '@/components/Form/Field/field'
import RadioButton from '@/components/Form/RadioButton/radio-button'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import List from '@/components/List/list'
import {clientMixin} from '@/mixins/clientMixin'

export default {
  name: 'UserForm',
  mixins: [clientMixin],
  components: {
    FormGroup,
    Dropdown,
    Field,
    RadioButton,
    ButtonCta,
    Heading,
    List
  },
  props: {
    user: Object,
    submit: Function,
    isAddUser: Boolean
  },
  created () {
    this.getClients().then(() => {
      this.$emit('loading', false)
    })
  },
  data: () => ({
    roles: {
      options: [
        {
          name: 'Admin',
          value: 1
        },
        {
          name: 'Editor',
          value: 2
        },
        {
          name: 'Render Bot',
          value: 3
        },
        {
          name: 'Client Admin',
          value: 4
        },
        {
          name: 'Role Publisher',
          value: 5
        }
      ]
    }
  })
}
</script>

<style lang="scss">
    @import "./user-form";
</style>



// WEBPACK FOOTER //
// src/components/UserForm/user-form.vue